const placeholderPattern = /{([^{}]*)}/g;

export function extractPlaceholders(value: string | null): string[] {
    if (!value) {
        return [];
    }

    const names: string[] = [];
    let match = placeholderPattern.exec(value);
    while (match !== null) {
        if (names.indexOf(match[1]) === -1) {
            names.push(match[1]);
        }
        match = placeholderPattern.exec(value);
    }

    return names.sort();
}

export function placeholdersMatch(previous: string | null, next: string): boolean {
    if (previous === null || previous === undefined) {
        return true;
    }

    return extractPlaceholders(previous).join(' ') === extractPlaceholders(next).join(' ');
}
